import InspectionForm from '@/views/inspections/InspectionForm.vue'

export default [
	{
		name: 'inspection',
		path: '/vehicles/:id/inspection/:typeId/:inspectionId?',
		component: InspectionForm,
		meta: { 
			back: (route) => ({ name: 'get-vehicle', params: { id: route.params.id }}), 
		},
	},
]